import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function FloatingSidebar() {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="fixed right-4 bottom-20 z-40 flex flex-col items-end gap-2">
      {expanded && (
        <>
          <Link
            to="/contact"
            className="flex items-center gap-2 bg-white shadow-lg rounded-full px-4 py-2.5 text-sm text-primary hover:bg-surface-warm transition-colors"
          >
            <span className="w-8 h-8 flex items-center justify-center bg-accent/10 rounded-full">
              <i className="ri-calendar-check-line text-accent" />
            </span>
            <span className="whitespace-nowrap">预约专属客服</span>
          </Link>
          <button
            onClick={() => alert('企业微信客服功能即将上线')}
            className="flex items-center gap-2 bg-white shadow-lg rounded-full px-4 py-2.5 text-sm text-primary hover:bg-surface-warm transition-colors"
          >
            <span className="w-8 h-8 flex items-center justify-center bg-accent/10 rounded-full">
              <i className="ri-wechat-line text-accent" />
            </span>
            <span className="whitespace-nowrap">企业微信客服</span>
          </button>
          <button
            onClick={() => alert('电话咨询服务即将上线')}
            className="flex items-center gap-2 bg-white shadow-lg rounded-full px-4 py-2.5 text-sm text-primary hover:bg-surface-warm transition-colors"
          >
            <span className="w-8 h-8 flex items-center justify-center bg-accent/10 rounded-full">
              <i className="ri-phone-line text-accent" />
            </span>
            <span className="whitespace-nowrap">电话咨询</span>
          </button>
        </>
      )}
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-12 h-12 bg-accent text-white rounded-full shadow-lg flex items-center justify-center hover:bg-accent-light transition-colors"
      >
        <i className={`ri-${expanded ? 'close' : 'customer-service-2'}-line text-xl`} />
      </button>
    </div>
  );
}